<div class="dropzone">
  <input
    type="file"
    #fileDropRef
    id="fileDropRef"
    [accept]="acceptedExtensions"
    (change)="upload()"
  />
  <h1>
    <i class="fa-regular fa-cloud-arrow-up"></i>
  </h1>
  <h3>{{ app.text.dragDrop.drag }}</h3>
  <label for="fileDropRe">{{ app.text.dragDrop.browse }}</label>
</div>
